import React, {useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {changeModalVisibility} from '../../../../setup/slices/ModalSlice'
import {customerAnaVezne} from '../../../types'
import {sortSearchedCustomers} from '../../../../setup/slices/AnavezneSlice'
import './customerTable.css'

type Props = {
  setCustomerInfo: any
  customers: any
  setIsLoading: React.Dispatch<React.SetStateAction<boolean | undefined>>
  isLoading: boolean | undefined
}
const CustomersTable: React.FC<Props> = ({setCustomerInfo, customers, setIsLoading, isLoading}) => {
  const dispatch = useDispatch()

  const [sortedColumn, setSortedColumn] = React.useState<string>('')
  const [sortedData, setSortedData] = React.useState<any[]>([])
  const [sortOrder, setSortOrder] = useState('asc')

  const searchedCustomers = useSelector((state: RootState) => state.customers.searchedCustomers)

  const handleSort = (column: keyof customerAnaVezne) => {
    const newSortOrder = sortedColumn === column ? (sortOrder === 'asc' ? 'desc' : 'asc') : 'asc'
    dispatch(sortSearchedCustomers({column, sortOrder: newSortOrder}))

    setSortedColumn(column)
    setSortOrder(newSortOrder)
  }
  console.log('------------------------------------------------------', searchedCustomers)
  return (
    <div>
      <div className='table-responsive h-500px card-scroll'>
        {/* begin::Table */}
        <table className='table align-middle gs-0 gy-4'>
          {/* begin::Table head */}
          <thead style={{position: 'sticky', top: '0', zIndex: 2, backgroundColor: 'white'}} className='bg-light-primary border-bottom border-primary'>
            <tr className='fw-bolder text-gray-800 '>
              <th
                className='w-100px text-center tahsilatBaslik'
                style={{cursor: 'pointer'}}
                onClick={() => handleSort('Customerreference')}
              >
                Kodu
                {/* {sortOrder === 'desc' ? (
                  <i className='bi bi-sort-down sortHandle'></i>
                ) : (
                  <i className='bi bi-sort-up sortHandle'></i>
                )} */}
              </th>
              <th
                className='w-100px text-center  tahsilatBaslik'
                style={{cursor: 'pointer'}}
                onClick={() => handleSort('Customerreference')}
              >
                SAP No
              </th>
              <th
                className='min-w-200px text-center tahsilatBaslik'
                style={{cursor: 'pointer'}}
                onClick={() => handleSort('CustName')}
              >
                Müşteri Adı
              </th>
              <th
                className='min-w-130px text-center tahsilatBaslik'
                style={{cursor: 'pointer'}}
                onClick={() => handleSort('VergiNo')}
              >
                VK No
              </th>
              <th
                className='min-w-100px text-center tahsilatBaslik'
                style={{cursor: 'pointer'}}
                onClick={() => handleSort('StoreId')}
              >
                Anavezne Kodu
              </th>
              <th
                className='min-w-100px text-center tahsilatBaslik'
                style={{cursor: 'pointer'}}
                onClick={() => handleSort('StoreDesc')}
              >
                Anavezne Adı
              </th>
            </tr>
          </thead>

          <tbody >
            {isLoading === undefined ? (
              <td colSpan={6} className='text-center'>
                <h1>Lütfen Vezne Seçiniz.</h1>
              </td>
            ) : isLoading ? (
              <td colSpan={6} className='text-center'>
                <h1>Yükleniyor...</h1>
              </td>
            ) : searchedCustomers && searchedCustomers.length === 0 ? (
              <td colSpan={6} className='text-center'>
                <h1 className=''>Müşteri Bulunamadı.</h1>
              </td>
            ) : searchedCustomers !== undefined ? (
              searchedCustomers.map((customer: any, index: number) => (
                <tr key={index}>
                  <td>
                    <div className='d-flex align-items-center text-hover-primary justify-content-center font-size-xl w-100px h-40px'>
                      <span
                        className='text-primary fw-bolder text-decoration-underline fs-5 textYellow'
                        onClick={() => {
                          return dispatch(changeModalVisibility(true)), setCustomerInfo(customer)
                        }}
                        style={{cursor: 'pointer'}}
                      >
                        {customer.Customerreference}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div className='d-flex align-items-center text-hover-primary justify-content-center font-size-xl w-150px h-40px'>
                      <span
                        className='text-dark text-decoration-underline fs-5 textYellow'
                        onClick={() => {
                          return dispatch(changeModalVisibility(true)), setCustomerInfo(customer)
                        }}
                        style={{cursor: 'pointer'}}
                      >
                        {customer.AtCustNo}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div
                      className='d-flex align-items-center text-hover-primary'
                      onClick={() => {
                        return dispatch(changeModalVisibility(true)), setCustomerInfo(customer)
                      }}
                      style={{cursor: 'pointer'}}
                    >
                      <div className='d-flex justify-content-center flex-column'>
                        <span className='text-dark fw-bolder text-hover-primary fs-4'>
                          {customer.CustName}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className='text-dark text-center d-block fs-5'>
                      <span>{customer.VergiNo}</span>
                    </div>
                  </td>
                  <td className='text-center'>
                    <div className='text-dark fw-bolder  d-block fs-7'>
                      <span>{customer.StoreId !== null ? customer.StoreId : '-Bilgi Yok-'}</span>
                    </div>
                  </td>
                  <td className='text-center'>
                    <div className='text-warning fw-bolder d-block fs-7'>
                      <span>
                        {customer.StoreDesc !== null ? customer.StoreDesc : '-Bilgi Yok-'}
                      </span>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td>
                  <h2> Yükleniyor ...</h2>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default CustomersTable
